import { Component } from 'react';
import { inject, observer } from 'mobx-react';

class FacebookPixelPurchase extends Component {

	constructor(props) {
		super(props);
		if (typeof window.fbq === "function") { 
			const cashsale = this.props.shopStore.cashsale.get();
			//console.log('XXXX', cashsale);
			window.fbq(
				'track', 
				'Purchase', 
				{
					value: cashsale.total,
					currency: cashsale.currencysymbol,
					/*contents: [
						{
						id: '301',
						quantity: 1,
						item_price: 85.00
						},
						{
						id: '401',
						quantity: 2,
						item_price: 15.00
						}],
					content_type: 'product',
					compared_product: 'recommended-banner-shoes'  // custom property*/
				}
			);
		}
	}

	render() {
		return null;
	}

}

export default inject('shopStore')(observer(FacebookPixelPurchase));



// WEBPACK FOOTER //
// ./src/components/FacebookPixelPurchase.js